exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader!../~/postcss-loader!../~/stylus-loader!./ui/customers/styles.styl
// module id = 946
// module chunks = 0